import { writable } from "svelte/store";
import { labeledCheckboxes } from "../constants/checkboxes";
import { get } from "svelte/store";

const setupCheckboxes = () => {
  return get(labeledCheckboxes).reduce((acc: Record<string, boolean>, { identifier, defaultValue }) => {
    acc[identifier] = defaultValue;
    return acc;
  }, {});
};

export type RegistrationStore = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  consoleOption: string;
  dob: {
    month: string;
    day: string;
    year: string;
  };
  checkboxStatuses: Record<string, boolean>;
  lockedEmail: boolean;
};

export const registrationStore = writable<RegistrationStore>({
  firstName: '',
  lastName: '',
  email: '',
  consoleOption: '',
  dob: {
    month: '',
    day: '',
    year: ''
  },
  checkboxStatuses: setupCheckboxes(),
  lockedEmail: false
});
